module.exports = __webpack_public_path__ + "static/crew.ef302f3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/crew.png
// module id = 463
// module chunks = 76778261247453